export enum ATMTerminalFeeCalculationMethods {
  CALCULATE_FROM_TRANSACTION_AMOUNT = 'CALCULATE_FROM_TRANSACTION_AMOUNT',
  CALCULATE_FROM_TERMINAL_FEE_FIELD = 'CALCULATE_FROM_TERMINAL_FEE_FIELD',
  CALCULATE_FROM_TERMINAL_FEE_TRANSACTION = 'CALCULATE_FROM_TERMINAL_FEE_TRANSACTION',
}

export default ATMTerminalFeeCalculationMethods;
